import React, { useEffect }  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form } from 'antd';
import RegisterAnimalFields from "./RegisterAnimalFields";
import { 
	getAnimalInventoryDetails, doAnimalInventoryCreate, 
	doAnimalInventoryUpdate, doInventoryTransferUpdate
} from "../../../../redux/farmanimal/farmAnimalState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { FormatDateValue, getAnimalTypeRoute } from "../../../../utils/index";
import OpenModalButton from "components/button/modalbutton";
import { Select } from 'antd';
import FormItem from "components/fields/FormItem";
import TextAreaField from "components/fields/TextAreaField";
import { requiredField } from '../../../../utils/crudSagaHelper';

const AnimalInventoryForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, animalTypeId, doUpdateInventory, ...props}) => {
	const { recordId, mode } = props;  	
	const [form] = useForm();
	
	useEffect(() => {		
		getRecord({recordId: recordId, type_id: animalTypeId});
	}, [recordId, getRecord, animalTypeId]);
	
	useEffect(() => {
		if(recordData){
			const { date_of_birth, birth_type_id, horn_status_id, ...restData } = recordData;
			const initialValues = {
				date_of_birth: date_of_birth ? FormatDateValue(date_of_birth) : null,
				type_id:animalTypeId,
				birth_type_id: birth_type_id === 0 ? null : birth_type_id,
				horn_status_id: horn_status_id === 0 ? null : horn_status_id,
				...restData				
			};
			form.setFieldsValue(initialValues);
		}
	}, [recordData, form]);
	
	const onSubmit = (formData) => {	
		try {
			formData.date_of_birth = formData.date_of_birth ? formData.date_of_birth.format('YYYY-MM-DD') : null;
			formData.type_id = animalTypeId;
			formData.id = recordId ?? 0;
			formData.id > 0 ? doUpdate(formData): doCreate(formData); 
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

	const onTransferHandler = () => {
		const accountId = form.getFieldValue('transfer_account_id');
		if(accountId > 0 ){
			const { id, tag_id, farm_id, breeder_account_id } = recordData;
			doUpdateInventory({
				animal_id: id, 
				original_tag_id: tag_id, 
				from_farm_id: farm_id, 
				from_account_id: breeder_account_id, 
				to_account_id: form.getFieldValue('transfer_account_id'),
				remarks: form.getFieldValue('transfer_remarks'),
			});
			
			return true;
		}

		return false;
	}

	return (
		<Card extra={"w-full h-full p-4"}>
			<Form form={form} className="form"
				layout="vertical"
				onFinish={onSubmit}
			>   
				<RegisterAnimalFields recordData={recordData} mode={mode} form={form} isAdmin={true} typeId={animalTypeId}/>

				<CrudButtons 
					baseRoute={`/console/animal-inventory/${getAnimalTypeRoute(animalTypeId)}`} 
					mode={mode} 
					recordId={recordId}
					withEdit={recordData?.was_transfered === 'No'}
				>
					{recordData?.was_transfered === 'No' && 
						<OpenModalButton 
							label="Transfer"
							submitHandler={onTransferHandler}
							>
							<h4 className="ml-4 card-title mb-4">Process Animal Transfer</h4>
							<FormItem extra="col-span-1 md:col-span-2"
								name="transfer_account_id"
								label="Transfer to Account"
								layout="vertical"
								rules={[requiredField()]}
							>
								<Select id="transfer_account_id"
									allowClear={true}
									showSearch
									options={recordData?.accountOptions}
									filterOption={(input, option) =>
										(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
										}
								/>	
												
							</FormItem>
							<FormItem extra="col-span-1 md:col-span-2 mb-5"
								name="transfer_remarks"
								label="Remarks"
								layout="vertical"
							>
								<TextAreaField id="transfer_remarks"
									maxLength={1000}
								/>	
												
							</FormItem>
						</OpenModalButton>
					}
				</CrudButtons>
			</Form>	 	
		</Card>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.farmAnimal.inventoryDetails?.data,
	requesting: state.farmAnimal.inventoryDetails?.requesting,
	success: state.farmAnimal.inventoryDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getAnimalInventoryDetails(id)),
	doCreate: (data) => dispatch(doAnimalInventoryCreate(data)),
	doUpdate: (data) => dispatch(doAnimalInventoryUpdate(data)),
	doUpdateInventory: (data) => dispatch(doInventoryTransferUpdate(data)),
	
});

export default connect(mapStateToProps, mapDispatchToProps)(AnimalInventoryForm);